document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-nav-toggle]');
  if (!t) return;
  var nav = document.querySelector('[data-nav]');
  if (!nav) return;
  var open = nav.classList.toggle('is-open');
  t.setAttribute('aria-expanded', open ? 'true' : 'false');
});

/* Gravur: Live-Vorschau + Zeichenzähler */
document.addEventListener('input', function (e) {
  var input = e.target.closest('[data-engrave-input]');
  if (!input) return;
  var box = input.closest('[data-engrave]');
  if (!box) return;
  var preview = box.querySelector('[data-engrave-preview]');
  var count = box.querySelector('[data-engrave-count]');
  if (preview) preview.textContent = input.value || preview.getAttribute('data-empty') || '';
  if (count) count.textContent = input.value.length + ' / ' + (input.getAttribute('maxlength') || '');
});
document.addEventListener('change', function (e) {
  var sel = e.target.closest('[data-engrave-font]');
  if (!sel) return;
  var box = sel.closest('[data-engrave]');
  var preview = box && box.querySelector('[data-engrave-preview]');
  if (preview) preview.style.fontFamily = sel.getAttribute('data-font') || sel.value;
});
document.addEventListener('DOMContentLoaded', function () {
  var sel = document.querySelector('[data-engrave-font]:checked');
  var preview = document.querySelector('[data-engrave-preview]');
  if (sel && preview) preview.style.fontFamily = sel.getAttribute('data-font') || '';
});

/* Produktgalerie: Miniatur wechselt das Hauptbild, Klick öffnet die Lightbox */
(function () {
  var images = [];
  var current = 0;

  function box() { return document.querySelector('[data-lightbox]'); }

  function load() {
    var data = document.querySelector('[data-gallery-data]');
    if (!data) return;
    try { images = JSON.parse(data.textContent) || []; } catch (err) { images = []; }
  }

  function show(i) {
    var lb = box();
    if (!lb || !images.length) return;
    current = (i + images.length) % images.length;
    var img = lb.querySelector('[data-lightbox-img]');
    var count = lb.querySelector('[data-lightbox-count]');
    img.src = images[current].src;
    img.alt = images[current].alt || '';
    if (count) count.textContent = (current + 1) + ' / ' + images.length;
    var one = images.length < 2;
    lb.querySelector('[data-lightbox-prev]').hidden = one;
    lb.querySelector('[data-lightbox-next]').hidden = one;
  }

  function open(i) {
    var lb = box();
    if (!lb) return;
    show(i);
    lb.hidden = false;
    document.body.classList.add('lightbox-open');
  }

  function close() {
    var lb = box();
    if (!lb) return;
    lb.hidden = true;
    document.body.classList.remove('lightbox-open');
  }

  document.addEventListener('DOMContentLoaded', load);
  load();

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-gallery-main]');
      if (main) {
        main.src = thumb.getAttribute('data-large');
        main.setAttribute('data-index', thumb.getAttribute('data-index'));
      }
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }
    if (e.target.closest('[data-gallery-open]')) {
      var el = document.querySelector('[data-gallery-main]');
      open(parseInt(el && el.getAttribute('data-index'), 10) || 0);
      return;
    }
    if (e.target.closest('[data-lightbox-close]')) { close(); return; }
    if (e.target.closest('[data-lightbox-prev]')) { show(current - 1); return; }
    if (e.target.closest('[data-lightbox-next]')) { show(current + 1); return; }
  });

  document.addEventListener('keydown', function (e) {
    var lb = box();
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });
})();
